import {
  DialogActions,
  DialogContent,
  DialogTitle
} from "@mui/material";
import { Form } from "formik";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import {
  clearAffectedZones,
  getAffectedZones,
} from "../../../../actions/forms";
import CustomDialog from "../../../commons/dialog/customDialog";
import FormikActions from "../../../commons/formik/formikActions";
import FormikAutocomplete from "../../../commons/formik/formikAutocomplete";
import FormikForm from "../../../commons/formik/formikForm";
import FormikTextField from "../../../commons/formik/formikTextField";
import CircularLoading from "../../../commons/loadingData/circularLoading";
import { StyledPrestacionesAdd } from "../../../styled/form";

const validation = Yup.object({
  id: Yup.string().required("Campo obligatorio"),
  cantidad: Yup.number().required("Campo obligatorio"),
  zonaAfectada: Yup.string().required("Campo obligatorio").nullable(),
});

const PrestacionesAdd = ({ prestacion, open, handleClose, handleSubmit }) => {
  const dispatch = useDispatch();
  const prestacionesState = useSelector((state) => state.forms.prestaciones);
  const affectedZonesState = useSelector((state) => state.forms.affectedZones);

  const [cantidadDisabled, setCantidadDisabled] = useState(true);

  return (
    <CustomDialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>Agregar prestación</DialogTitle>
      {prestacionesState.isFetching ? (
        <StyledPrestacionesAdd.CircularLoadingContainer>
          <CircularLoading />
        </StyledPrestacionesAdd.CircularLoadingContainer>
      ) : (
        <FormikForm
          initialValues={prestacion}
          validationSchema={validation}
          onSubmit={(values) => {
            handleSubmit(values);
          }}>
          {({ values, setFieldValue }) => (
            <Form>

              <DialogContent>
                <FormikAutocomplete
                  name="id"
                  label="Prestación *"
                  options={prestacionesState.data}
                  sx={{ marginBottom: 2 }}
                  callBack={(value) => {
                    if (value) {
                      if (value.cantidadFija) {
                        setFieldValue("cantidad", 1);
                        setCantidadDisabled(true);
                      } else {
                        setCantidadDisabled(false);
                      }
                      if (value.subnomenclador) {
                        setFieldValue("subnomenclador", value.subnomenclador);
                      }
                      if (values.id != value.id) {
                        setFieldValue("zonaAfectada", "");
                        dispatch(clearAffectedZones());
                      }
                    } else if (!value) {
                      setFieldValue("zonaAfectada", "");
                      dispatch(clearAffectedZones());
                    }
                  }}
                  renderOption={(option) => `${option.id} - ${option.nombre}`}
                  filterOptions={(option) => option.id + option.nombre}
                />
                <FormikTextField
                  name="cantidad"
                  label="Cantidad *"
                  type="number"
                  sx={{ marginBottom: 2 }}
                  disabled={cantidadDisabled}
                />
                <FormikAutocomplete
                  name="zonaAfectada"
                  label="Zona del cuerpo *"
                  getOptions={() => {
                    dispatch(getAffectedZones(values.id));
                  }}
                  options={affectedZonesState.data}
                  sx={{ marginBottom: 2 }}
                  disabled={!values.id}
                />
              </DialogContent>
              <DialogActions>
                <FormikActions handleCancel={handleClose} />
              </DialogActions>
            </Form>
          )}
        </FormikForm>
      )}
    </CustomDialog>
  );
};

export default PrestacionesAdd;
